import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function ClearIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="9.5"
        fill="none"
        stroke="currentColor"
      />
      {/* Checkmark */}
      <path
        d="M7.5 10.5L9.5 12.5L13 8.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
